import { observable, action, computed, toJS, makeObservable } from 'mobx';
import BaseFilters from './helpers/BaseFilters';

export default class StoreReports extends BaseFilters {
    skip = 0;
    limit = 25;
    sortBy = 'createdOn';
    sortDirection = 'DESC';
    newReportGenerated = 0;

    initialState = {
        limit: 25,
        skip: 0,
        sortBy: 'createdOn',
        sortDirection: 'DESC'
    };

    constructor() {
        super();

        makeObservable(this, {
            skip: observable,
            limit: observable,
            sortBy: observable,
            sortDirection: observable,
            newReportGenerated: observable,
            reportState: computed
        });
    }

    //Computed values can be used to derive information from other observables.
    get reportState() {
        return toJS(this.initialState);
    }
}
